import { atom } from "recoil";

const fillFormStatusAtom = atom({
  key: "fillFormStatus",
  default: {},
});

export default fillFormStatusAtom;
